module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.carrito.length > 0) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "box-style line-top"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-date"
  }, [_c('a', {
    staticClass: "regular",
    attrs: {
      "href": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelarClicked($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" cancelar pedido")])]), _vm._v(" "), _c('div', {
    staticClass: "box-date"
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkout-step1"
  }, [_vm._l((_vm.carrito), function(item) {
    return _c('div', {
      staticClass: "order-per-day"
    }, [_c('div', {
      staticClass: "box-body"
    }, [(!_vm.estaCompletoMenuDia(item.fecha) && _vm.proveedores) ? _c('div', {
      staticClass: "pull-right"
    }, [_c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("El menú no está completo para el día")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "checkout-alert"
    }, [_c('span', {}, [_vm._v("LA EMPRESA ABONA EL " + _vm._s(_vm.getPorcentajeSubsidio(item.fecha)) + "% DEL VALOR DE TUS PEDIDOS")]), _vm._v(" "), _c('span', {
      staticClass: "hide"
    }, [_vm._v("LA EMPRESA ABONARÁ EL 50% DEL VALOR DE TUS PEDIDOS DE TU RECIBO DE SUELDO")])]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatearFecha")(item.fecha)))])]), _vm._v(" "), _vm._l((item.proveedor), function(proveedor) {
      return _c('div', {
        key: proveedor._id,
        staticClass: "row"
      }, _vm._l((proveedor.platos), function(plato) {
        return _c('div', {
          key: plato._id,
          staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6",
          staticStyle: {
            "padding-top": "5px"
          }
        }, [_c('div', {
          staticClass: "box-order"
        }, [_c('div', {
          staticClass: "box-order-photo",
          style: ({
            backgroundImage: 'url(' + plato.plato.urlThumb + ')'
          })
        }), _vm._v(" "), _c('div', {
          staticClass: "box-order-detail"
        }, [_c('p', {
          staticClass: "box-order-category"
        }, [_vm._v(_vm._s(plato.plato.categoria.nombre))]), _vm._v(" "), _c('p', {
          staticClass: "box-order-name",
          class: {
            'text-danger': _vm.noDisponibles.indexOf(plato.plato._id) >= 0
          }
        }, [_vm._v(" " + _vm._s(plato.plato.nombre) + "\n                        "), (_vm.noDisponibles.indexOf(plato.plato._id) >= 0) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v("Sin stock suficiente")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "box-order-foot"
        }, [_c('div', {
          staticClass: "quantity"
        }, [_c('span', {
          staticClass: "qty-value"
        }, [_vm._v(_vm._s(plato.cantidad))])])])])])])
      }))
    })], 2), _vm._v(" "), (_vm.precioCombo) ? _c('div', {
      staticClass: "box-bottom total"
    }, [_vm._m(1, true), _vm._v(" "), _c('span', {
      staticClass: "total-value"
    }, [_vm._v("Total del día: " + _vm._s(_vm._f("formatearMoneda")(_vm.getSubtotal(item.fecha))))]), _vm._v(" "), _c('br')]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "box-bottom total final"
  }, [_c('span', [_vm._v("GENERAL")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "total-value"
  }, [_vm._v("TOTAL: " + _vm._s(_vm._f("formatearMoneda")(_vm.subtotalGeneral)))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.user._id) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-text"
  }, [_c('p', {
    staticClass: "text-size-18"
  }, [_vm._v("Recibe "), _c('span', {
    staticClass: "semibold"
  }, [_vm._v(_vm._s(_vm.user.displayName))])]), _vm._v(" "), _c('p', {
    staticClass: "text-size-18"
  }, [_c('span', {
    staticClass: "semibold"
  }, [_vm._v(_vm._s(_vm.user.sucursalAsociada.empresa.razonSocial) + " - " + _vm._s(_vm.user.sucursalAsociada.denominacion))])]), _vm._v(" "), _c('p', {
    staticClass: "text-size-18"
  }, [_vm._v(_vm._s(_vm.user.sucursalAsociada.direccion.direccion))])]), _vm._v(" "), _c('div', {
    staticClass: "box-actions text-center smart-form"
  }, [_c('p', {
    staticClass: "text-center margin-bottom-20"
  }, [_c('label', {
    staticClass: "checkbox inline-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aceptaCondiciones),
      expression: "aceptaCondiciones"
    }],
    attrs: {
      "type": "checkbox",
      "name": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.aceptaCondiciones) ? _vm._i(_vm.aceptaCondiciones, null) > -1 : (_vm.aceptaCondiciones)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.aceptaCondiciones,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.aceptaCondiciones = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.aceptaCondiciones = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.aceptaCondiciones = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v("He revisado el pedido y es exactamente lo que quiero recibir\n                    ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-fill",
    class: {
      disabled: !_vm.puedeConfirmarPedido
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickConfirmar($event)
      }
    }
  }, [_vm._v("CONFIRMAR")])])]) : _vm._e()], 2)])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', {
    staticClass: "hide"
  }, [_vm._v("1.")]), _vm._v(" DETALLES DE TU PEDIDO")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hide"
  }, [_c('b', [_vm._v("-")]), _vm._v(" Descuento: $63.98 "), _c('b', [_vm._v("=")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hide"
  }, [_c('b', [_vm._v("-")]), _vm._v(" DESCUENTO: $63.98 "), _c('b', [_vm._v("=")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h1', [_vm._v("DATOS DE ENVÍO")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03af9208"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pedido/Checkout.vue
// module id = 1103
// module chunks = 5